/**
 * The base of every failure that means the backend's response does not match the contract: a
 * body that fails validation, an action or event type the engine does not know, a replay whose
 * result contradicts its snapshot. Retrying returns the same body, so the shell offers a reload
 * (decision, 2026-09-13). The shell recognises the class, never a name.
 */
export class ProtocolError extends Error {
  public constructor(message: string) {
    super(message);
    this.name = "ProtocolError";
  }
}
